import BaseObject from '../../../base/base_object';
import Model from './info_model';
import Device from '../../../utils/device';
import HybridInfo from '../../hybrid/features/info/info_hybrid_feature';

/**
 *
 *
 *
 */
class InfoService extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'InfoService';


    /**
     * @property
     * @type {null}
     * @private
     */
    _model = null;

    /**
     *
     * @param params
     */
    init(params) {
        this._model = Model.create(params);
    }

    /**
     *
     * @returns {*}
     */
    getData(infoOk, infoError){

        let infoWebOk = (strWeb)=>{

            let infoHybridOk = (strHybrid)=> {
                infoOk(strWeb + " !!! " + strHybrid);
            }

            if (Device.isHybrid()) {
                HybridInfo.create().getInfo(infoHybridOk, infoError);
            }else{
                infoOk(strWeb);
            }
        }

        this._model.getData(infoWebOk, infoError);
    }
}
export default InfoService;